import Swiper, { Navigation, Pagination } from 'swiper';


  // configure Swiper to use modules
  Swiper.use([Navigation, Pagination]);

/********** Témoignage SwipeJs ***********/

var swiper = new Swiper(".swiperSlide", {
  loop: false,
  slidesPerView: 'auto',
  spaceBetween: 130,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});